import { render } from "./Header.vue?vue&type=template&id=6fe6b187&ref=myElement"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script